import { render } from "./CustomerViewPersonalData.vue?vue&type=template&id=c4ebe40c&scoped=true"
import script from "./CustomerViewPersonalData.vue?vue&type=script&lang=js"
export * from "./CustomerViewPersonalData.vue?vue&type=script&lang=js"

import "./CustomerViewPersonalData.vue?vue&type=style&index=0&id=c4ebe40c&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4ebe40c"]])

export default __exports__